<script>
import baseMixin from '@/mixins/baseMixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RemoveLoginDialogAndButton',
  mixins: [baseMixin],
  props: {
    candidateId: {
      type: Number,
      required: true,
    },
    candidateName: {
      type: String,
      required: true,
    },
  },
  data: () => {
    return {
      dialog: false,
    }
  },
  computed: {
    ...mapGetters({
      isLoadingCandidateUserDetailsCRUD:
        'candidate/isLoadingCandidateUserDetailsCRUD',
    }),
  },
  methods: {
    ...mapActions({ removeLogin: 'candidate/removeLogin' }),
    async handleRemove() {
      const response = await this.removeLogin(this.candidateId)

      if (!response.isSuccess) return

      this.$emit('login-removed')

      this.dialog = false
    },
  },
}
</script>

<template>
  <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        id="remove-login-button"
        color="error"
        text
        v-bind="attrs"
        v-on="on"
        >{{ $t('candidate.removeLoginBtnLabel') }}</v-btn
      >
    </template>
    <v-card id="remove-login-dialog-card" tile class="overflow-x-hidden">
      <h6 class="text-h6">{{ $t('candidate.removeLoginDialogTitle') }}</h6>
      <p class="text-body-2">{{
        $t('candidate.removeLoginDialogPrompt', { candidateName })
      }}</p>
      <v-card-actions class="justify-end pa-0">
        <v-btn
          color="primary"
          text
          :disabled="isLoadingCandidateUserDetailsCRUD"
          @click="dialog = false"
        >
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn
          id="remove-button"
          color="error"
          :loading="isLoadingCandidateUserDetailsCRUD"
          @click="handleRemove"
        >
          {{ $t('general.remove') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
